import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    border: '2px solid #ddddddb8',
    borderRadius: '8px',
    boxSizing: 'border-box',
    maxWidth: 160,
    padding: '0.5rem',
    background: 'white',
    cursor: 'pointer',
    animation: '$glow 0.5s linear infinite alternate',
    animationIterationCount: 3,
    transition: '400ms',

    '&:hover': {
      border: `2px solid ${theme.palette.primary.main}`
    }
  },

  title: {
    cursor: 'inherit',
    userSelect: 'none'
  },

  closeBtn: {
    flexShrink: 0,
    marginLeft: '0.5rem',

    '&:hover': {
      fill: 'lightgrey',
      transition: '0.2s'
    }
  },

  '@keyframes glow': {
    '0%': {
      boxShadow: `0 4px 10px 0 ${theme.palette.primary.main}`
    },

    '100%': {
      backgroundColor: `0 4px 10px 0 ${theme.palette.secondary.main}`
    }
  }
}))

export default useStyles
